module.exports = __webpack_public_path__ + "img/131.fd0e33c1.jpg";